import { ILogger } from '@sparkware/uc-sdk-core';
import Container from 'typedi';
import { LoggerProvider } from '../../logger';
import { ILoginOptions, IAuthenticationStorage } from '../models';
import merge from 'lodash/merge';

export class AuthenticationStorage implements IAuthenticationStorage {
    private _loginOptions: ILoginOptions = {};
    private _logger: ILogger;
    constructor() {
        this._logger = Container.get(LoggerProvider).getLogger('AuthenticationStorage');
    }

    public getLoginOptions = (): ILoginOptions => {
        this._logger.debug(`getLoginOptions: returning login options: `, this._loginOptions);

        return this._loginOptions;
    };

    public setLoginOptions = (options: ILoginOptions = {}): void => {
        this._logger.debug(`setLoginOptions: setting login options to: `, this._loginOptions);

        this._loginOptions = options;
    };

    public updateLoginOptions = (options: ILoginOptions = {}) => {
        this._logger.debug(
            `updateLoginOptions: update login options from a merge between ${JSON.stringify(
                this._loginOptions,
            )} and ${JSON.stringify(options)}`,
        );
        const mergedOptions = merge(this._loginOptions, options);
        this._logger.debug(`updateLoginOptions: merged options:`, mergedOptions);

        this._loginOptions = mergedOptions;
    };
}
